import { createTransformedImports, isBabelApi } from './utils.js';
function createSignaliumAsyncTransform(api, opts) {
    const transformedImports = createTransformedImports([
        ['callback', ['signalium']],
        ['component', ['signalium/react']],
        ['reactive', ['signalium']],
        ['reactiveMethod', ['signalium']],
        ['relay', ['signalium']],
        ['task', ['signalium']],
        ['watcher', ['signalium']],
        ['useReactive', ['signalium/react']],
        ['useReactiveShallow', ['signalium/react']],
        ['useReactiveDeep', ['signalium/react']],
    ], opts?.transformedImports, opts?.importPaths);
    const t = api.types;
    const isTrackedImport = (localName, path) => {
        const binding = path.scope.getBinding(localName);
        if (!binding || !t.isImportSpecifier(binding.path.node))
            return false;
        const importSpec = binding.path.node;
        const importedName = importSpec.imported.name;
        const importDecl = binding.path.parent;
        if (!t.isImportDeclaration(importDecl))
            return false;
        const importPaths = transformedImports.get(importedName);
        if (!importPaths)
            return false;
        return importPaths.some(p => typeof p === 'string' ? importDecl.source.value === p : p.test(importDecl.source.value));
    };
    const isReactiveCall = (path) => {
        if (!t.isCallExpression(path.node))
            return false;
        const callee = path.node.callee;
        if (!t.isIdentifier(callee))
            return false;
        return isTrackedImport(callee.name, path);
    };
    const isWithinTrackedCall = (path) => {
        let current = path.parentPath;
        while (current) {
            if (current.isCallExpression() && isReactiveCall(current))
                return true;
            current = current.parentPath;
        }
        return false;
    };
    function convertReactiveToGenerator(path) {
        if (!isWithinTrackedCall(path))
            return;
        if (!path.node.async)
            return;
        path.traverse({
            AwaitExpression(awaitPath) {
                const funcParent = awaitPath.getFunctionParent();
                if (funcParent?.node !== path.node)
                    return;
                awaitPath.replaceWith(t.yieldExpression(awaitPath.node.argument));
            },
        });
        path.node.async = false;
        if (t.isArrowFunctionExpression(path.node)) {
            let hasThis = false;
            path.traverse({
                ThisExpression() {
                    hasThis = true;
                },
            });
            const functionBody = t.isBlockStatement(path.node.body)
                ? path.node.body
                : t.blockStatement([t.returnStatement(path.node.body)]);
            const newFunction = t.functionExpression(null, path.node.params, functionBody, true, false);
            if (hasThis) {
                path.replaceWith(t.callExpression(t.memberExpression(newFunction, t.identifier('bind')), [t.thisExpression()]));
            }
            else {
                path.replaceWith(newFunction);
            }
        }
        else {
            path.node.generator = true;
        }
    }
    return {
        name: 'signalium-transform-reactive-async',
        visitor: {
            FunctionExpression: convertReactiveToGenerator,
            ArrowFunctionExpression: convertReactiveToGenerator,
        },
    };
}
export function signaliumAsyncTransform(apiOrOpts, maybeOpts) {
    if (isBabelApi(apiOrOpts)) {
        return createSignaliumAsyncTransform(apiOrOpts, maybeOpts);
    }
    return (api) => createSignaliumAsyncTransform(api, apiOrOpts);
}
